import { Component } from '@angular/core';
import { ProductMenuHeaderComponent } from '../../product-menu-header.component';

@Component({
  selector: 'app-plantlife-cheap-weed-header-empty',
  templateUrl: './menu-header-plantlife-cheap-weed-empty.component.html',
  styleUrls: ['./menu-header-plantlife-cheap-weed-empty.component.scss'],
  providers: [{ provide: ProductMenuHeaderComponent, useExisting: MenuHeaderPlantlifeCheapWeedEmptyComponent }],
  standalone: false
})
export class MenuHeaderPlantlifeCheapWeedEmptyComponent extends ProductMenuHeaderComponent {}
